<template>
  <!-- <loader-gif v-if="isRequestSync" :classes="'loader-index-9999'" /> -->
  <modal-browser :fiche_member="fiche_member" />

  <nav v-if="userUUID" class="navbar z-index-999">
    <a class="sidebar-toggler cursor-pointer " @click="toggle" :class="isTogglerActive ? 'active' : 'not-active'">
      <font-awesome-icon icon="bars" size="lg" />
    </a>
    <div class="navbar-content">
      <div class="row w-100">
        <div class="col-md-10">
          <div class="input-search-by-matricule  w-100">
            <input style="margin-top: 10px;" :placeholder="i18n.t('layout.navbar.form.search_member')"
              class="form-control w-100" v-model="searchBy.cin" @keyup.enter="searchMemberByCIN">
          </div>
        </div>

        <!-- <div class="col-md-6  ">
          <div class="input-search-by-matricule w-100">
            <router-link style="margin-top: 10px;" :to="{ name: 'inscription', params: { clubUUID: clubUUID } }"
              class="btn btn-primary w-100">
              <font-awesome-icon icon="fa-plus" size="lg" class="link-icon" />
              <span class="link-title"> {{ i18n.t('layout.navbar.form.new_subscriptions') }} </span>
            </router-link>
          </div>
        </div> -->

      </div>
      <ul class="navbar-nav">
        <li v-if="hasPermission('display_monitor_static') || hasPermission('display_monitor_multi')"
          class="nav-item dropdown cursor-pointer" @click="openTvMonitor">
          <a class="nav-link dropdown-toggle" href="javascript:void(0);">
            <element-tooltip :text="i18n.t('layout.navbar.alerts.tv.display_monitor')" position="left">
              <span class="alert-numbers">
                <font-awesome-icon icon="tv" size="lg" class="link-icon" />
              </span>
            </element-tooltip>
          </a>
        </li>
        <li class="nav-item dropdown     ">
          <a v-if="reloadQrCodeScan" @click="reloadQrCodeScan = !reloadQrCodeScan" class="nav-link dropdown-toggle  "
            href="javascript:void(0);">

            <element-tooltip :text="i18n.t('layout.navbar.alerts.camera.active')" position="left">
              <span class=" alert-numbers ">
                <font-awesome-icon :icon="'video-camera'" size="lg" class="link-icon" style="color: #279d54;" />

              </span>
            </element-tooltip>

          </a>
          <a @click="reloadQrCodeScan = !reloadQrCodeScan" v-else class="nav-link dropdown-toggle  "
            href="javascript:void(0);">

            <element-tooltip :text="i18n.t('layout.navbar.alerts.camera.inactif')" position="left">
              <span class=" alert-numbers ">
                <font-awesome-icon :icon="!reloadQrCodeScan ? 'video-slash' : 'video'" size="lg" class="link-icon" />

              </span>
            </element-tooltip>
          </a>
        </li>

        <li v-if="hasPermission('create_stock_orders')" class="nav-item dropdown   cursor-pointer "
          @click="redirectTo({ name: 'stock-add-order', params: { clubUUID: clubUUID } })">
          <a class="nav-link dropdown-toggle  " href="javascript:void(0);">
            <element-tooltip :text="i18n.t('layout.sidbar.stock.sales.add_order_product')" position="left">
              <span class=" alert-numbers ">
                <font-awesome-icon icon="cart-plus" size="lg" class="link-icon" />
              </span>
            </element-tooltip>


          </a>
        </li>
        <li v-if="hasPermission('create_stock_orders')" class="nav-item dropdown   cursor-pointer "
          @click="redirectTo({ name: 'stock-add-order-spa', params: { clubUUID: clubUUID } })">
          <a class="nav-link dropdown-toggle  " href="javascript:void(0);">
            <element-tooltip :text="i18n.t('layout.sidbar.stock.sales.add_order_service')" position="left">
              <span class=" alert-numbers ">
                <font-awesome-icon icon="spa" size="lg" class="link-icon" />
              </span>
            </element-tooltip>


          </a>
        </li>


        <li v-if="hasPermission('new_subscriptions')" class="nav-item dropdown cursor-pointer  "
          @click="redirectTo({ name: 'inscription', params: { clubUUID: clubUUID } })">
          <a class="nav-link dropdown-toggle  " href="javascript:void(0);">
            <element-tooltip :text="i18n.t('layout.sidbar.subscriptions.new_subscriptions')" position="left">
              <span class=" alert-numbers ">
                <font-awesome-icon icon="user-plus" size="lg" class="link-icon" />
              </span> </element-tooltip>


          </a>
        </li>


        <li v-if="hasPermission('credits')" class="nav-item dropdown cursor-pointer  "
          @click="redirectTo({ name: 'credits', params: { clubUUID: clubUUID } })">
          <a class="nav-link dropdown-toggle  " href="javascript:void(0);">
            <element-tooltip :text="i18n.t('layout.sidbar.regulations.credits')" position="left">
              <span class=" alert-numbers ">
                <font-awesome-icon icon="hand-holding-dollar" size="lg" class="link-icon" />
              </span>
            </element-tooltip>

          </a>
        </li>

        <li v-if="hasPermission('transactions')" class="nav-item  dropdown alerts  ">


          <a class="nav-link dropdown-toggle " href="javascript:void(0);" id="profileDropdowns" role="button"
            data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <element-tooltip :text="i18n.t('layout.navbar.alerts.payment_due_date.title')" position="left">
              <font-awesome-icon icon="calendar-alt" size="lg" class="link-icon" />
              <span class="alert-numbers">{{ transactions_due_dateCount }} </span>
            </element-tooltip>
          </a>
          <div class="dropdown-menu  " aria-labelledby="profileDropdowns">
            <div class="d-flex justify-content-between   dropdown-title">
              <p class="   ">
                {{ i18n.t('layout.navbar.alerts.payment_due_date.title') }}
              </p>
              <router-link v-if="hasPermission('transactions')"
                :to="{ name: 'encaissements', params: { clubUUID: clubUUID }, query: { paymentMethod: 'Chèque bancaire' } }"
                class="bg-none  ms-3">
                {{ i18n.t('button.display_all') }}
              </router-link>
            </div>
            <div v-if="transactions_due_dateList?.length > 0">
              <div v-for="(transaction, index) in transactions_due_dateList" class="  alert-items"
                v-bind:key="`${transaction.id}-${index}`">
                <div class="d-flex align-items-center justify-content-center item">
                  <div class="preview-thumbnail">
                    <path-image class="img-table" :path_image="transaction?.member?.path_image" />
                  </div>
                  <div class="alert-item-content flex-grow   ms-2">
                    <p class="preview-subject ellipsis font-weight-medium text-dark">
                      <b>
                        <p class="preview-subject ellipsis font-weight-medium text-dark">
                          <b>
                            <router-link v-if="transaction?.member?.uuid" class="bg-none"
                              :to="{ name: 'fiche', params: { clubUUID: clubUUID, memberUUID: transaction?.member?.uuid } }">
                              <span>
                                {{ transaction?.member?.matricule }},
                              </span>
                              <span class="ms-2">
                                {{ transaction?.member?.name }}
                              </span>
                            </router-link>
                          </b>
                        </p>
                      </b>
                    </p>
                    <p class="font-weight-light small-text">
                      <span>
                        <b style="font-weight: bold !important;"> {{ i18n.t('tables.payment.chequeNum') }} : </b>
                        {{ transaction?.chequeNum }}
                      </span>
                      <span class="ms-2">
                        <b style="font-weight: bold !important;"> {{ i18n.t('tables.payment.dueDate') }} :</b> {{
                          formatDate(transaction?.dueDate)
                        }}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="  alert-items">
              <not-found :text="i18n.t('message.data_not_found.title')" icon="warning" />
            </div>
          </div>

        </li>


        <li v-if="hasPermission('expired_subscriptions')" class="nav-item  dropdown alerts  ">

          <a class="nav-link dropdown-toggle " href="javascript:void(0);" id="profileDropdowns" role="button"
            data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <element-tooltip :text="i18n.t('layout.navbar.alerts.expired_subscriptions.title')" position="left">
              <font-awesome-icon icon="hourglass-end" size="lg" class="link-icon" />
              <span class="alert-numbers">{{ expired_subscriptionsCount }} </span>
            </element-tooltip>
          </a>
          <div class="dropdown-menu  " aria-labelledby="profileDropdowns">
            <div class="d-flex justify-content-between   dropdown-title">
              <p class="  ">
                {{ i18n.t('layout.navbar.alerts.expired_subscriptions.title') }}
              </p>
              <router-link v-if="hasPermission('expired_subscriptions')"
                :to="{ name: 'expired-subscriptions', params: { clubUUID: clubUUID } }" class="bg-none ms-3">
                {{ i18n.t('button.display_all') }}
              </router-link>
            </div>
            <div v-if="expired_subscriptionsList?.length > 0">
              <div v-for="(subscription, index) in expired_subscriptionsList" class="  alert-items"
                v-bind:key="`${subscription.id}-${index}`">
                <div class="d-flex align-items-center  justify-content-center item">
                  <div class="preview-thumbnail">
                    <path-image class="img-table" :path_image="subscription?.member_info?.path_image" />
                  </div>
                  <div class="alert-item-content flex-grow ms-2">
                    <p class="preview-subject ellipsis font-weight-medium text-dark">
                      <b>

                        <p class="preview-subject ellipsis font-weight-medium text-dark">
                          <b>
                            <router-link v-if="subscription?.member_info?.uuid" class="bg-none"
                              :to="{ name: 'fiche', params: { clubUUID: clubUUID, memberUUID: subscription?.member_info?.uuid } }">
                              <span>
                                {{ subscription?.member_info?.matricule }},
                              </span>
                              <span class="ms-2">
                                {{ subscription?.member_info?.name }}
                              </span>
                            </router-link>
                          </b>
                        </p>

                      </b>

                    </p>
                    <p class="font-weight-light small-text">
                      <span>
                        <b style="font-weight: bold !important;"> {{ i18n.t('tables.subscription_member.end_date') }} :
                        </b>
                        {{ formatDate(subscription?.end_date) }}
                      </span>
                      <span class="ms-2">
                        <b style="font-weight: bold !important;"> {{
                          i18n.t('tables.subscription_member.remaining_days')
                        }}
                          :</b> {{
                            subscription?.status?.remaining_days
                          }} {{ i18n.t('symbole.day') }}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="  alert-items">
              <not-found :text="i18n.t('message.data_not_found.title')" icon="warning" />
            </div>
          </div>

        </li>


        <li v-if="hasPermission('subscriptions_expiring')" class="nav-item  dropdown alerts  ">

          <a class="nav-link dropdown-toggle " href="javascript:void(0);" id="profileDropdowns" role="button"
            data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <element-tooltip :text="i18n.t('layout.navbar.alerts.subscriptions_expiring.title')" position="left">
              <font-awesome-icon icon="hourglass-half" size="lg" class="link-icon" />
              <span class="alert-numbers">{{ subscriptions_expiringCount }} </span>
            </element-tooltip>
          </a>
          <div class="dropdown-menu  " aria-labelledby="profileDropdowns">
            <div class="d-flex justify-content-between   dropdown-title">
              <p class="  ">
                {{ i18n.t('layout.navbar.alerts.subscriptions_expiring.title') }}
              </p>
              <router-link v-if="hasPermission('subscriptions_expiring')"
                :to="{ name: 'subscriptions-expiring', params: { clubUUID: clubUUID } }" class="bg-none ms-3">
                {{ i18n.t('button.display_all') }}
              </router-link>
            </div>
            <div v-if="subscriptions_expiringList?.length > 0">
              <div v-for="(subscription, index) in subscriptions_expiringList" class="  alert-items"
                v-bind:key="`${subscription.id}-${index}`">
                <div class="d-flex align-items-center  justify-content-center item">
                  <div class="preview-thumbnail">
                    <path-image class="img-table" :path_image="subscription?.member_info?.path_image" />
                  </div>
                  <div class="alert-item-content flex-grow ms-2">
                    <p class="preview-subject ellipsis font-weight-medium text-dark">
                      <b>

                        <router-link v-if="subscription?.member_info?.uuid" class="bg-none"
                          :to="{ name: 'fiche', params: { clubUUID: clubUUID, memberUUID: subscription?.member_info?.uuid } }">
                          <span>
                            {{ subscription?.member_info?.matricule }},
                          </span>
                          <span class="ms-2">
                            {{ subscription?.member_info?.name }}
                          </span>
                        </router-link>
                      </b>
                    </p>
                    <p class="font-weight-light small-text">
                      <span>
                        <b style="font-weight: bold !important;"> {{ i18n.t('tables.subscription_member.end_date') }}
                          : </b>
                        {{ formatDate(subscription?.end_date) }}
                      </span>
                      <span class="ms-2">
                        <b style="font-weight: bold !important;"> {{
                          i18n.t('tables.subscription_member.remaining_days')
                        }}
                          :</b> {{
                            subscription?.status?.remaining_days
                          }} {{ i18n.t('symbole.day') }}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="  alert-items">
              <not-found :text="i18n.t('message.data_not_found.title')" icon="warning" />
            </div>

          </div>

        </li>

        <li class="nav-item dropdown langs">

          <a class="nav-link dropdown-toggle  " href="javascript:void(0);" id="profileDropdown" role="button"
            data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span class="alert-numbers lang ">{{ selectedLang }}</span>
          </a>
          <div class="dropdown-menu " aria-labelledby="profileDropdown">
            <ul class="list-unstyled  ">

              <li v-for="(lang, index) in langs" class="dropdown-item d-flex cursor-pointer lang-item"
                :class="{ 'active-lang': selectedLang == lang }" @click="changeLanguage(lang)" v-bind:key="index">
                <span class="symbole-lang"> {{ i18n.t('lang.' + lang + '.symbole') }} </span>
                <span>{{ i18n.t('lang.' + lang + '.title') }} </span>
              </li>
            </ul>
          </div>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle " href="javascript:void(0);" id="profileDropdown" role="button"
            data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">

            <path-image class="wd-30 ht-30 rounded-circle" :path_image="user?.path_image ?? `/img/icons/member.png`" />
          </a>
          <div class="dropdown-menu  " aria-labelledby="profileDropdown">
            <div class="d-flex flex-column align-items-center bcustom-alert-bottom px-5 py-1 border-bottom">

              <div class="text-left">
                <p class="tx-16 text-uppercase ">
                  <b>{{ user?.firstName || '' }} {{ user?.lastName || '' }} </b>
                </p>
              </div>
              <div class="text-center">
                <p class="tx-16 "> <b>{{ i18n.t('layout.navbar.dropdown.selecetdClub') }} </b> {{ currentClub?.name ||
                  ''
                }} </p>
                <p class="tx-16 "> <b>ID : </b> {{ currentClub?.id }} </p>

              </div>
            </div>
            <ul class="list-unstyled ">
              <li v-if="hasAdminRole()" class="dropdown-item  cursor-pointer border-bottom">
                <router-link :to="{ name: 'clubs', params: { userUUID: userUUID } }"
                  class="bg-none text-body py-1 d-block w-100">
                  <font-awesome-icon icon="shop" size="lg" class="me-2 icon-md" />
                  <span> {{ i18n.t('layout.navbar.dropdown.admin_space') }} </span>
                </router-link>
              </li>

              <li class="dropdown-item  cursor-pointer border-bottom " @click="switchClub()">
                <a class="bg-none text-body  py-1 d-block w-100">
                  <font-awesome-icon icon="repeat" size="lg" class="me-2 icon-md" />
                  <span class="link-title"> {{ i18n.t('layout.navbar.dropdown.switch_club') }} </span>
                </a>
              </li>
              <!-- <li v-if="hasAdminRole()" class="dropdown-item  cursor-pointer border-bottom">
                <router-link :to="{ name: 'create-club', params: { userUUID: userUUID } }"
                  class="bg-none text-body py-1 d-block w-100">
                  <font-awesome-icon icon="plus" size="lg" class="me-2 icon-md" />
                  <span>{{ i18n.t('layout.navbar.dropdown.create_club') }} </span>
                </router-link>
              </li> -->
              <li class="dropdown-item  cursor-pointer border-bottom">
                <router-link :to="{ name: 'profile', params: { userUUID: userUUID } }"
                  class=" bg-none text-body py-1 d-block w-100">
                  <font-awesome-icon icon="user-tie" size="lg" class="me-2 icon-md" />
                  <span>{{ i18n.t('layout.navbar.dropdown.profile') }} </span>
                </router-link>
              </li>
              <li class="dropdown-item  cursor-pointer border-bottom">
                <router-link :to="{ name: 'support', params: { userUUID: userUUID } }"
                  class=" bg-none text-body py-1 d-block w-100">
                  <font-awesome-icon icon="headset" size="lg" class="me-2 icon-md" />
                  <span>{{ i18n.t('layout.navbar.dropdown.support') }} </span>
                </router-link>
              </li>

              <li class="dropdown-item  cursor-pointer" @click.prevent="logout">
                <a class="bg-none text-body  py-1 d-block w-100">
                  <font-awesome-icon icon="sign-out-alt" size="lg" class="me-2 icon-md" />
                  <span>{{ i18n.t('layout.navbar.dropdown.logout') }} </span>
                </a>
              </li>


            </ul>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script lang="ts">
import Swal from "sweetalert2";
import { useRoute } from "vue-router"
import i18n from "@/i18n/index"
import { defineComponent, ref, computed, onMounted, watch } from 'vue';
import { selectedLang, userUUID, clubUUID, currentClub, user } from '@/shared/state';
import {
  reloadQrCodeScan, transactions_due_date, expired_subscriptions, subscriptions_expiring, transactions_due_date_count, expired_subscriptions_count, subscriptions_expiring_count,

  isTogglerActive, isSidebarFolded, isSidebarOpen
} from '@/shared/state'

import { useGlobal } from "@/composables/global/useGlobal";
import { useLogin } from '@/composables/auth/useLogin';
import { useClub } from '@/composables/club/useClub';
import { useModal } from '@/composables/modal/useModal';
import { useMember } from "@/composables/member/useMember";
import { usePermission } from "@/composables/auth/usePermission";
import { MemberSearchParams, SyncSubscriptionMembersSearchParams } from "@/interfaces/member";
import { useUser } from "@/composables/auth/useUser";

export default defineComponent({
  name: 'NavBar',
  setup() {
    const APP_URL = process.env.VUE_APP_URL;
    const route = useRoute()
    const { formatDate, redirectTo, languages } = useGlobal();
    const langs = languages()
    const { getUserPermissions, hasPermission } = usePermission();
    /**fetch user permission */
    getUserPermissions({ userUUID: userUUID.value, clubUUID: clubUUID.value })

    const transactions_due_dateList = computed(() => transactions_due_date.data);
    const expired_subscriptionsList = computed(() => expired_subscriptions.data);
    const subscriptions_expiringList = computed(() => subscriptions_expiring.data);

    const transactions_due_dateCount = computed(() => transactions_due_date_count);
    const expired_subscriptionsCount = computed(() => expired_subscriptions_count);
    const subscriptions_expiringCount = computed(() => subscriptions_expiring_count);
    const fiche_member: any = ref(null)
    const searchBy = ref<MemberSearchParams>({
      id: null,
      clubUUID: clubUUID.value,
      memberUUID: "",
      matricule: "",
      name: "",
      email: "",
      tele: "",
      cin: "",
      dateBirth: [],
      gender: "",
      contractNumber: "",
      seller_id: null,
      hasSubscriptionActive: "", // true to get all members has subscription active
      type: "first",
      page: 0,
      limit: 0,
      with_subscriptions: "false",
      with_current_subscription: "false",
      with_seller: "false",
      with_transactions: "false"
    });

    /** fetch active subscription and sync pointeuses */
    const searchActiveSubscription = ref<SyncSubscriptionMembersSearchParams>({
      clubUUID: clubUUID.value,
      matricule: "",
      isActive: true,
      with_name: true,
      with_matricule: true,
      with_pointeuses: true,
      with_active_subsctription: true
    });

    const { logout, error } = useLogin();
    const { switchClub } = useClub();
    const { openModal } = useModal();
    const { fetchMemberByCIN, isRequestSync } = useMember();

    const { hasAdminRole } = useUser();







    // }
    const searchMemberByCIN = () => {
      if (searchBy?.value?.cin?.trim() === '') {
        return;
      }
      fetchMemberByCIN(searchBy.value).then((response) => {

        if (response?.member_info?.id) {
          fiche_member.value = response || null
          openModal('modal_browser', 'add', null)
          searchBy.value.cin = null
        } else {
          Swal.fire({
            title: i18n.t("message.not_found.member_not_found.title"),
            icon: "warning",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "OK",
            allowOutsideClick: false,   // ✅ disable closing by clicking outside
            allowEscapeKey: false       // (optional) disable closing with ESC
          })
        }
      })
    };

    const changeLanguage = (lang: string) => {
      localStorage.setItem('selectedLang', lang)
      i18n.setLocale(lang)
      selectedLang.value = lang
      const dir = lang === "ar" ? 'rtl' : 'ltr';
      if (lang == "ar") {
        localStorage.setItem('style', 'rtl')
      } else {
        localStorage.setItem('style', 'ltr')
      }

      document.body.classList.add(dir?.toString());
      document.documentElement.setAttribute("dir", dir?.toString());
      location.reload();
    };








    // Toggle sidebar
    const toggle = () => {
      isTogglerActive.value = !isTogglerActive.value
      if (window.matchMedia("(min-width: 992px)").matches) {
        isSidebarFolded.value = !isSidebarFolded.value
        isSidebarOpen.value = false
      } else {
        isSidebarOpen.value = !isSidebarOpen.value
        isSidebarFolded.value = false
      }
      document.body.classList.toggle("sidebar-folded", isSidebarFolded.value)
      document.body.classList.toggle("sidebar-open", isSidebarOpen.value)
    }

    const cameraPermission = ref('');

    const checkCameraPermission = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true })

        // If we reach here → permission granted
        cameraPermission.value = 'granted'
        // Stop camera immediately (important)
        stream.getTracks().forEach(track => track.stop())
      } catch (error: any) {

        if (error.name === 'NotAllowedError') {
          cameraPermission.value = 'denied'
        } else if (error.name === 'NotFoundError') {
          cameraPermission.value = 'no-camera'
        } else {
          cameraPermission.value = 'error'
        }
      }
    }

    onMounted(checkCameraPermission);


    const videoRef = ref(null);

    const activateCamera = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        if (videoRef.value) {
          //   videoRef.value.srcObject = stream;
        }
      } catch (error) {
        console.error("Failed to access camera:", error);
      }
    };

    const openTvMonitor = () => {
      if (typeof window !== 'undefined') {
        if (hasPermission('display_monitor_static')) {
          window.open(`${APP_URL}hikvision/single/${currentClub.value.slug}/1`, '_blank');

        } else if (hasPermission('display_monitor_multi')) {
          window.open(`${APP_URL}hikvision/multi/${currentClub.value.slug}`, '_blank');

        }
      }
    };


    return {
      activateCamera,
      openTvMonitor,
      videoRef,
      cameraPermission,
      isTogglerActive,
      toggle,
      transactions_due_dateCount,
      expired_subscriptionsCount,
      subscriptions_expiringCount,
      transactions_due_dateList,
      expired_subscriptionsList,
      subscriptions_expiringList,
      switchClub,
      logout,
      currentClub,
      userUUID,
      clubUUID,
      error,
      searchMemberByCIN,
      searchBy,
      fiche_member,
      changeLanguage,
      i18n,
      user,
      selectedLang,
      formatDate,
      hasAdminRole,
      hasPermission,
      redirectTo,
      isRequestSync,
      langs,
      reloadQrCodeScan
    };
  },
});
</script>

<!--  toggle() {
      var body = $("body");
      $(".sidebar-header .sidebar-toggler").toggleClass("active not-active");
      if (window.matchMedia("(min-width: 992px)").matches) {
        body.toggleClass("sidebar-folded");
      } else if (window.matchMedia("(max-width: 991px)").matches) {
        body.toggleClass("sidebaropen");
      }
    }, -->
<style lang="scss">
.text-dark {
  color: #343a40 !important;
}


.alert-items {
  p {
    font-size: 12px;
  }

  padding: 10px 15px;
  border-top: 1px solid #d7d7d7;
}
</style>